import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { ButtonClose } from '@design-system/button';
export const CloseButton = ({ onClick, screenReadersText }) => (_jsx(CloseStyled, { onClick: onClick, screenReadersText: screenReadersText }));
const CloseStyled = styled(ButtonClose) `
  margin: 16px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
`;
//# sourceMappingURL=CloseButton.js.map